import React, { useEffect } from 'react';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/lib/LanguageContext';
import Header from '@/components/casa/Header';
import Hero from '@/components/casa/Hero';
import TrustBadges from '@/components/casa/TrustBadges';
import Pain from '@/components/casa/Pain';
import Services from '@/components/casa/Services';
import WhoWeAre from '@/components/casa/WhoWeAre';
import Trust from '@/components/casa/Trust';
import Contact from '@/components/casa/Contact';
import Footer from '@/components/casa/Footer';
import WhatsAppButton from '@/components/casa/WhatsAppButton';

function App() {
  useEffect(() => {
    document.title = 'Casa Serena · KeyHolding & Property Management Costa Blanca';
  }, []);

  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-cream text-ink-900 font-sans">
        <Header />
        <main>
          <Hero />
          <TrustBadges />
          <Pain />
          <Services />
          <WhoWeAre />
          <Trust />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: '#F9F8F6',
              color: '#2D332F',
              border: '1px solid #E2DED8',
              borderRadius: '4px',
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
